module.exports = "/_next/static/images/google-play-icon-c723d146f50d3b956b3c401edf1c7973.png";